import { render } from "./ConsiderationTab.vue?vue&type=template&id=0f9bb67c&scoped=true"
import script from "./ConsiderationTab.vue?vue&type=script&lang=js"
export * from "./ConsiderationTab.vue?vue&type=script&lang=js"

import "./ConsiderationTab.vue?vue&type=style&index=0&id=0f9bb67c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f9bb67c"]])

export default __exports__